define('adminColorSelectionsListRowToolsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'bootbox',
  'tableFieldView',
  'adminColorSelectionsEditPopupView',
  'template!adminColorSelectionsListRowToolsView',
  'entities/admin/color_selections'
], function (
  Module,
  App,
  _,
  $,
  Bootbox,
  FieldView,
  EditPopupView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-color-selections-list-row-tools-view table-field-view',

    events: {
      'click .btn-edit': 'onEdit',
      'click .btn-delete': 'onDelete'
    },

    serializeData: function () {
      return {
        editLabel: _.i18n('common.edit', null, 'Edit'),
        deleteLabel: _.i18n('common.delete', null, 'Delete')
      };
    },

    onEdit: function (e) {
      e.stopPropagation();
      var tableView = this.options.tableView;
      EditPopupView.open(this.model.get('secId'), function () { tableView.reloadAll(); });
    },

    onDelete: function (e) {
      e.stopPropagation();
      var self = this;
      var techniques = this.model.get('techniques') || [];
      if (techniques.length) {
        Bootbox.alert(_.i18n('admin.colorSelections.deleteUsed', null,
          'This selection is offered by these imprint technologies, unlink it from them first:') +
          ' ' + _.escape(_.pluck(techniques, 'code').join(', ')));
        return;
      }
      Bootbox.confirm(_.i18n('admin.colorSelections.confirmDelete', null, 'Delete this colour selection?') +
        ' <b>' + _.escape(this.model.get('code') || '') + '</b>', function (ok) {
        if (!ok) { return; }
        App.request('colorSelections:delete', self.model.get('secId')).done(function () {
          self.options.tableView.reloadAll();
        }).fail(function (xhr) {
          var reason = xhr && xhr.responseJSON && xhr.responseJSON.error;
          Bootbox.alert(reason ? _.escape(reason) : _.i18n('common.error', null, 'Something went wrong. Please try again.'));
        });
      });
    }
  });
});

